<template>
  <details class="cw-panel">
    <summary>Bankzahlungen abgleichen</summary>
    <div class="cw-stack cw-top-space">
      <p class="cw-small">CAMT.053 oder CAMT.054 hochladen. Es werden nur eindeutige CHF-Zahlungen auf V2-Rechnungen vorgeschlagen.</p>
      <label class="cw-label">Bankdatei<input class="cw-input" type="file" accept=".xml,application/xml,text/xml" :disabled="busy" @change="choose"></label>
      <p v-if="error" class="cw-error" role="alert">{{ error }}</p><p v-if="message" class="cw-notice" role="status">{{ message }}</p>
      <template v-if="preview">
        <label v-for="row in preview.matched" :key="row.id" class="cw-check"><input v-model="selected" type="checkbox" :value="row.id" :disabled="busy"><span>{{ row.name }} · {{ money(row.amountCents) }}<span class="cw-small cw-block">{{ row.invoiceNumber }} · {{ date(row.date) }}</span></span></label>
        <p v-if="!preview.matched.length" class="cw-small">Keine weiteren eindeutigen Zahlungseingänge gefunden.</p>
        <p v-for="(row, index) in preview.unmatched" :key="index" class="cw-small">{{ row.reference }} · {{ row.reason }}</p>
        <button type="button" class="cw-button cw-primary" :disabled="busy || !selected.length" @click="confirm">{{ selected.length }} Zahlung(en) verbuchen</button>
      </template>
    </div>
  </details>
</template>
<script>
import api from "@/api/contractWorkspaceOfficeApi"
import { errorMessage } from "@/api/contractWorkspaceApi"
import { money, date } from "./workspaceFormat"
export default {
  data: () => ({ xml: "", preview: null, selected: [], busy: false, error: "", message: "" }),
  methods: {
    money, date,
    async choose(event) {
      const file = event.target.files && event.target.files[0]
      this.preview = null; this.selected = []; this.error = ""; this.message = ""
      if (!file) return
      if (file.size > 8 * 1024 * 1024) { this.error = "Die Datei darf maximal 8 MB gross sein."; return }
      this.busy = true; this.$emit("busy", true)
      try { this.xml = await file.text(); this.preview = await api.camtPreview(this.xml); this.selected = this.preview.matched.map(row => row.id) }
      catch (error) { this.error = errorMessage(error) }
      finally { this.busy = false; this.$emit("busy", false) }
    },
    async confirm() {
      if (this.busy || !this.selected.length) return
      this.busy = true; this.error = ""; this.$emit("busy", true)
      try { const result = await api.camtConfirm({ xml: this.xml, fingerprint: this.preview.fingerprint, paymentIds: this.selected }); this.message = result.updated.length + " Zahlung(en) verbucht."; this.$emit("refresh") }
      catch (error) { this.error = errorMessage(error) + " Bereits verbuchte Teilmengen erscheinen nicht erneut in der Vorschau." }
      finally {
        try { this.preview = await api.camtPreview(this.xml); this.selected = this.preview.matched.map(row => row.id) } catch (error) { this.preview = null; this.selected = [] }
        this.busy = false; this.$emit("busy", false)
      }
    },
  },
}
</script>
